import { Container, ExternalLink, Note, Row, TextLink } from '../../components/ui';
import Gallery from '../../components/case-study/Gallery';
import usePageMeta from '../../hooks/usePageMeta';
import { findNext } from '../../data/projects';

export default function CaseStudy({ project }) {
  usePageMeta(`${project.title} — Timothy Gilbert`, project.summary);
  const next = findNext(project.slug);
  const { code, live } = project.links;

  return (
    <Container className="pb-16 pt-4 md:pb-24">
      <Note>
        <TextLink to="/">← Portfolio</TextLink>
      </Note>

      <div className="mt-8 grid grid-cols-1 gap-x-8 gap-y-6 md:grid-cols-12">
        <div className="md:col-span-8">
          <h1 className="font-display text-h1">{project.title}</h1>
          <p className="mt-6 max-w-measure font-body text-lead">{project.summary}</p>
        </div>
        <div className="md:col-span-4 md:pt-3">
          <Note>Stack</Note>
          <Note as="ul">
            {project.stack.map((s) => (
              <li key={s}>{s}</li>
            ))}
          </Note>
          {(code || live) && (
            <Note as="ul" className="mt-4">
              {code && (
                <li>
                  <ExternalLink href={code}>Code</ExternalLink>
                </li>
              )}
              {live && (
                <li>
                  <ExternalLink href={live}>Live site</ExternalLink>
                </li>
              )}
            </Note>
          )}
        </div>
      </div>

      <section aria-labelledby="screens-title" className="mt-12 md:mt-16">
        <h2 id="screens-title" className="sr-only">
          Screens
        </h2>
        {/* key resets the gallery position when moving between projects */}
        <Gallery key={project.slug} images={project.images} />
      </section>

      {project.body.length > 0 && (
        <section aria-labelledby="about-title" className="mt-16 grid grid-cols-1 gap-x-8 md:grid-cols-12">
          <h2 id="about-title" className="mb-6 font-display text-h2 md:col-span-12">
            About the project
          </h2>
          <div className="max-w-measure space-y-5 md:col-span-8">
            {project.body.map((para) => (
              <p key={para}>{para}</p>
            ))}
          </div>
        </section>
      )}

      <nav aria-label="Next project" className="mt-16 border-b border-rule md:mt-24">
        <Row to={next.path}>
          <div className="md:col-span-8">
            <Note>Next project</Note>
            <p className="mt-1 font-display text-h3">
              <span className="box-decoration-clone transition-colors duration-fast group-hover:bg-mark group-hover:text-on-mark group-focus-visible:bg-mark group-focus-visible:text-on-mark">
                {next.title} →
              </span>
            </p>
          </div>
        </Row>
      </nav>
    </Container>
  );
}
